import type { Theme, ThemeId } from './theme.types';

export const DEFAULT_THEME_ID: ThemeId = 'gold_beige';

export const THEMES: Record<ThemeId, Theme> = {
  gold_beige: {
    id: 'gold_beige',
    name: 'Золотой беж',
    description: 'Роскошный, элегантный, премиальный',
    colors: {
      background: '#FFFFFF',
      surface: '#F8F5EE',
      primary: '#D4AF37',
      secondary: '#BFAE8A',
      text: '#6B5E3D',
      heading: '#2E2E2E',
      decoration: '#F9E7D9',
    },
  },
  powder_rose: {
    id: 'powder_rose',
    name: 'Пудрово-розовый',
    description: 'Романтичный, нежный, элегантный',
    colors: {
      background: '#FFFFFF',
      surface: '#FFF5F5',
      primary: '#F7C8D8',
      secondary: '#D8A7B7',
      text: '#6B4F5B',
      heading: '#3A2F36',
      decoration: '#FCE7EF',
    },
  },
  lavender: {
    id: 'lavender',
    name: 'Лавандовый',
    description: 'Стильный, спокойный, современный',
    colors: {
      background: '#FFFFFF',
      surface: '#F5F3FF',
      primary: '#A78BFA',
      secondary: '#C9B8F7',
      text: '#5B4B8A',
      heading: '#2E1F47',
      decoration: '#EDE7FF',
    },
  },
  emerald: {
    id: 'emerald',
    name: 'Изумрудный',
    description: 'Благородный, свежий, современный',
    colors: {
      background: '#FFFFFF',
      surface: '#F7FAF9',
      primary: '#10B981',
      secondary: '#6EE7B7',
      text: '#064E3B',
      heading: '#022C22',
      decoration: '#D1FAE5',
    },
  },
  blue_graphite: {
    id: 'blue_graphite',
    name: 'Синий графит',
    description: 'Строгий, стильный, премиальный',
    colors: {
      background: '#FFFFFF',
      surface: '#F1F5F9',
      primary: '#3B82F6',
      secondary: '#93C5FD',
      text: '#1E3A8A',
      heading: '#0F172A',
      decoration: '#DBEAFE',
    },
  },
  warm_peach: {
    id: 'warm_peach',
    name: 'Тёплый персик',
    description: 'Уютный, лёгкий, романтичный',
    colors: {
      background: '#FFFFFF',
      surface: '#FFF7F3',
      primary: '#FFB4A2',
      secondary: '#FFD6C2',
      text: '#8B5E3C',
      heading: '#5C3A2E',
      decoration: '#FFECE3',
    },
  },
  burgundy_chic: {
    id: 'burgundy_chic',
    name: 'Бургундский шик',
    description: 'Глубокий, насыщенный, элегантный',
    colors: {
      background: '#FFF7F6',
      surface: '#FBE9E8',
      primary: '#6B1028',
      secondary: '#9E2944',
      text: '#54202D',
      heading: '#310B18',
      decoration: '#D96A7C',
    },
  },
  deep_indigo: {
    id: 'deep_indigo',
    name: 'Глубокий индиго',
    description: 'Строгий, благородный, современный',
    colors: {
      background: '#F4F6FC',
      surface: '#E7ECF8',
      primary: '#17264A',
      secondary: '#304B80',
      text: '#243653',
      heading: '#0B1733',
      decoration: '#6F8FCB',
    },
  },
  emerald_freshness: {
    id: 'emerald_freshness',
    name: 'Изумрудная свежесть',
    description: 'Свежий, натуральный, спокойный',
    colors: {
      background: '#F3F8F5',
      surface: '#E3F0EA',
      primary: '#064B46',
      secondary: '#087D73',
      text: '#174B45',
      heading: '#062E2B',
      decoration: '#5CB9A8',
    },
  },
  terracotta_comfort: {
    id: 'terracotta_comfort',
    name: 'Терракотовый уют',
    description: 'Тёплый, домашний, уютный',
    colors: {
      background: '#FFF6F0',
      surface: '#FCE8DC',
      primary: '#A83D16',
      secondary: '#C65A2C',
      text: '#71371F',
      heading: '#482014',
      decoration: '#E88A5B',
    },
  },
  amethyst_dream: {
    id: 'amethyst_dream',
    name: 'Аметистовая мечта',
    description: 'Загадочный, нежный, сказочный',
    colors: {
      background: '#F8F5FC',
      surface: '#EEE7F8',
      primary: '#4B3476',
      secondary: '#7657A5',
      text: '#49385F',
      heading: '#28183F',
      decoration: '#A98BCF',
    },
  },
  sea_breeze: {
    id: 'sea_breeze',
    name: 'Морской бриз',
    description: 'Свежий, лёгкий, воздушный',
    colors: {
      background: '#F1F7FB',
      surface: '#E2EEF6',
      primary: '#145B91',
      secondary: '#367FB2',
      text: '#214B69',
      heading: '#102C46',
      decoration: '#78B6D9',
    },
  },
};

export const THEME_IDS = Object.keys(THEMES) as ThemeId[];

export function isThemeId(value: unknown): value is ThemeId {
  return typeof value === 'string' && value in THEMES;
}
